import BossModel from "@/models/BossModel";

export default class Dataset extends BossModel {

    static apiUrl = 'dataset';

    static call(action, filters = {}) {
        return this.api().action(action).filtered(filters).getValue();
    }

}
